export { default } from '../../../menu/(menu)/[slug]/index';
export * from '../../../menu/(menu)/[slug]/index';
